import React from 'react'

const Linkedin = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M7.74402 24.3829C1.96869 22.5989 -0.990021 17.1014 0.298297 10.6946C1.38453 5.29814 5.68208 0.950071 10.7027 0.163818C16.1876 -0.691903 21.6061 1.85947 24.249 6.5391C28.6034 14.2532 24.0059 23.4704 15.1771 24.7997C12.692 25.1723 10.2638 25.0524 7.74402 24.3829Z"
            fill="#666059"
        />
        <path
            d="M18.7025 10.5373C19.2961 11.0173 19.6656 11.5541 19.7603 12.1951C20.0824 14.3612 20.2624 16.5463 20.0761 18.7314C19.9719 19.9881 18.9393 19.4071 18.2731 19.4703C17.6352 19.5334 17.1489 19.4071 17.1963 18.523C17.2626 17.2505 17.2563 15.9653 17.1963 14.6928C17.1521 13.6886 17.1079 12.5898 15.6901 12.5519C14.5502 12.5203 14.026 13.155 13.9913 14.6643C13.9629 15.94 13.925 17.222 14.0008 18.4946C14.0639 19.505 13.445 19.4797 12.8072 19.4766C12.1504 19.4703 11.2441 19.846 11.1589 18.6903C10.9694 16.0948 11.0168 13.4929 11.1336 10.8941C11.1652 10.1584 11.6578 10.0668 12.2514 10.0352C13.6471 9.95945 13.8176 10.0258 14.1871 11.0362C15.5385 9.77631 17.0163 9.55843 18.7025 10.5373Z"
            fill="#FBFBFB"
        />
        <path
            d="M9.69863 16.9358C9.68915 17.3841 9.65758 17.7062 9.67968 18.0251C9.75862 19.1335 9.37023 19.6861 8.17349 19.7176C6.9799 19.7461 6.64519 19.2345 6.58835 18.1136C6.47783 15.8779 6.49362 13.6455 6.4873 11.413C6.4873 10.3047 6.98305 9.86263 8.05034 9.87526C9.045 9.88789 9.65442 10.1468 9.63547 11.3309C9.60074 13.1561 9.67337 14.978 9.69863 16.9358Z"
            fill="#F8F8F8"
        />
        <path
            d="M9.66086 7.10528C9.53138 7.96427 9.29137 8.64642 8.43553 8.79485C7.52916 8.9496 6.79964 8.618 6.54384 7.699C6.29119 6.78947 6.68595 6.04416 7.57969 5.77257C8.62817 5.4536 9.4398 5.75678 9.66086 7.10528Z"
            fill="#F8F8F8"
        />
    </svg>
)

export default Linkedin
